import React from 'react';
import { Box, Slider, Tooltip, IconButton, TooltipProps } from '@mui/material';

// Icone stile "Filled" (Default)
import VolumeOffIcon from '@mui/icons-material/VolumeOff';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';

// Icone stile "Outlined"
import VolumeOffOutlinedIcon from '@mui/icons-material/VolumeOffOutlined';
import VolumeUpOutlinedIcon from '@mui/icons-material/VolumeUpOutlined';
import { circularIconHoverSx } from '@/styles/iconHover';

interface VolumeControlProps {
    volume: number;
    muted: boolean;
    onVolumeChange: (event: Event, newValue: number | number[]) => void;
    onToggleMute: () => void;
    sliderPlacement?: TooltipProps['placement'];
    iconColor?: string;
    iconSize?: number | string;
    /** Sceglie lo stile delle icone. Di base usa le icone piene. */
    variant?: 'filled' | 'outlined';
}

export const VolumeControl: React.FC<VolumeControlProps> = ({
                                                                volume,
                                                                muted,
                                                                onVolumeChange,
                                                                onToggleMute,
                                                                sliderPlacement = 'bottom-end',
                                                                iconColor,
                                                                iconSize,
                                                                variant = 'filled', // Impostiamo 'filled' come valore di default
                                                            }) => {
    const slider = (
        <Box sx={{ bgcolor: 'background.paper', width: 120, paddingInline: 2, paddingBlock: 0 }}>
            <Slider
                value={volume}
                onChange={onVolumeChange}
                min={0}
                max={100}
                valueLabelDisplay="auto"
            />
        </Box>
    );

    const iconStyle = {
        color: iconColor,
        fontSize: iconSize,
    };


    const renderIcon = () => {
        if (variant === 'outlined') {
            return muted ? (
                <VolumeOffOutlinedIcon sx={iconStyle} />
            ) : (
                <VolumeUpOutlinedIcon sx={iconStyle} />
            );
        }


        return muted ? (
            <VolumeOffIcon sx={iconStyle} />
        ) : (
            <VolumeUpIcon sx={iconStyle} />
        );
    };

    return (
        <Tooltip
            title={slider}
            placement={sliderPlacement}
            interactive
            disableFocusListener
            slotProps={{ tooltip: { sx: { p: 0, outline: '1px solid #3b3b3bff', lineHeight: 0 } } }}
        >
            <IconButton
                aria-label={muted ? "Riattiva volume" : "Silenzia volume"}
                size="small"
                onClick={onToggleMute}
                sx={circularIconHoverSx()}
            >
                {renderIcon()}
            </IconButton>
        </Tooltip>
    );
};